<template>
  <div>
    <div>
      <base-title :title="StringLanguage.orders">
        <base-button
          @click="drawers.filter.open = !drawers.filter.open"
          class="m_auto w-100 filter"
          :class="{ reverse: !!isMobile }"
          design="two"
        >
          <p class="filter" v-if="!isMobile">
            <i class="fal fa-calendar-day"></i>
          </p>
          <p class="filter" v-else>Filtrar período</p>
        </base-button>
      </base-title>
    </div>

    <base-box class="box-search">
      <div class="d-flex justify-between align-center mb_5 flex-wrap">
        <div class="d-flex align-center">
          <base-label text="Buscar pedido" class="mb_0" />
          <span class="tag period" v-if="!noPeriod && !isMobile">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
            <i @click="removePeriod" class="fal fa-times remove-filter"></i>
          </span>
        </div>
        <span class="tag">{{
          `${loading ? 0 : this.countOrders.total} ocorrências`
        }}</span>

        <span class="tag period" v-if="!noPeriod && !!isMobile">
          {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
          <i @click="removePeriod" class="fal fa-times remove-filter"></i>
        </span>
      </div>

      <base-input
        placeholder="Procure por cliente, telefone ou número."
        class="w-100 mb_0"
        v-model="term"
        search
        @input="isTyping = true"
        @keyup="loading = false"
      />
    </base-box>

    <!-- Labels Mobile -->
    <div class="m-show">
      <base-tabs
        :tabs="getTabs()"
        @change="setIndex"
        :tabActived="tabActived"
        class="two"
      />
    </div>
    <!-- fim labels mobile -->

    <!-- Kanban -->
    <div v-if="loading" class="search-loading">
      <base-loading />
    </div>
    <orders-kanban
      v-else
      @change-status="changeStatus"
      @remove-order-from-change-status="usncheduleOrderStatus"
      @open-order="openOrder"
      :orders="aOrders"
      :countByStatus="countOrders"
      :status="selectedIndex"
      :loading="loading"
      :tabIndex="selectedIndex === 0 ? 2 : selectedIndex"
    />

    <infinite-loading
      v-if="!isMobile || !infiniteHandlerLimit"
      spinner="wavedots"
      @infinite="infiniteHandler"
      class="mt_30"
    >
      <div slot="no-more"></div>
      <div slot="no-results">
        <base-empty
          v-if="!this.countOrders.total"
          title="Você ainda não tem pedidos realizados."
          message="Todos os pedidos irão aparecer aqui."
        />
      </div>
    </infinite-loading>

    <!-- Drawer Pedido -->
    <base-drawer
      :open="drawerDetail"
      :close="drawerDetailClose"
      :title="`${StringLanguage.order} #${
        this.targetOrder.order_id
      }  -  ${getStatusName(targetOrder.status)}`"
      @onOpen="startDrawerTimer(targetOrder)"
      @onClose="resetTimer()"
    >
      <orders-detail
        :printers="printers"
        v-if="targetOrder.id"
        :order.sync="targetOrder"
        :catalog="catalog"
        :key="targetOrderReload"
        @change-status="changeStatus"
      />

      <template slot="footer">
        <div class="d-flex justify-between" v-if="targetOrder.id">
          <div
            class="w-100"
            v-if="
              targetOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS &&
              targetOrder.status === Status.IN_PRODUCTION
            "
          >
            <base-button
              @click="
                drawerDetailClose =
                  true &&
                  changeStatus({
                    id: targetOrder.id,
                    status: Status.ON_DELIVERY,
                    originalStatus: targetOrder.status,
                  })
              "
              v-if="!timerId"
              :text="StringLanguage.onDelivery"
              class="w-100 big"
            />
            <base-button
              v-else
              @click="
                drawerDetailClose =
                  true && usncheduleOrderStatus(targetOrder.schedule)
              "
              :text="statusChangeTimer | timerLabel"
              class="w-100 big"
            />
          </div>
          <div v-else class="w-100">
            <base-button
              @click="
                drawerDetailClose =
                  true &&
                  changeStatus({
                    id: targetOrder.id,
                    status: Status.FINISHED,
                    originalStatus: targetOrder.status,
                  })
              "
              v-if="!timerId && targetOrder.status !== Status.FINISHED"
              :text="
                targetOrder.status == 3
                  ? StringLanguage.finishOrder
                  : StringLanguage.ReadyToPickup
              "
              class="w-100 big"
            />
            <base-button
              v-else-if="timerId"
              @click="
                drawerDetailClose =
                  true && usncheduleOrderStatus(targetOrder.schedule)
              "
              :text="statusChangeTimer | timerLabel"
              class="w-100 big"
            />
            <base-button
              @click="print('reprintTicket')"
              v-if="targetOrder.status == 4"
              class="w-100 big"
              design="four"
              title="Imprimir 2a via"
            >
              Imprimir 2a via
            </base-button>
          </div>

          <div class="d-flex">
            <base-button
              @click="editOrder(targetOrder.id)"
              v-if="isOrderEditable()"
              design="four"
              class="ml_15"
              title="Editar pedido"
            >
              <i class="fal fa-pen fs-12"></i>
            </base-button>
            <base-button
              @click="print('reprintTicket')"
              v-if="targetOrder.status <= 3"
              design="four"
              class="ml_15"
              title="Imprimir 2a via"
            >
              <i class="fal fa-print fs-12"></i>
            </base-button>
          </div>
        </div>
      </template>
    </base-drawer>

    <!-- Drawer Filtro -->
    <filter-period
      :open="drawers.filter.open"
      :close="drawers.filter.close"
      @filter="filterPeriod"
      :allFilter="true"
      :maxCustomRange="0"
      :defaultOption="filterType"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Status, OrderOrigin } from 'easyjs/lib/Schema/Order';
import { Status as ScheduleStatus } from 'easyjs/lib/Schema/Scheduler';
import { DeliveryType } from 'easyjs/lib/Schema/Delivery';
import {
  DeliveryPlatform as DeliveryPlatformEnum,
  PlatformShippingStatus,
} from 'easyjs/lib/Schema/Delivery/DeliveryPlatform';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import DateTimeTools from 'easyjs/lib/Tools/DateTime';
import dayjs from 'dayjs';
import InfiniteLoading from 'vue-infinite-loading';
import BaseDrawer from '@/components/Drawer';
import BaseEmpty from '@/components/Empty';
import OrdersKanban from '@/containers/Orders/OrdersKanban';
import OrdersDetail from '@/containers/Orders/OrdersDetail';
import FilterPeriod from '@/containers/FilterPeriod';
import OrderAPI from '@/api/order';
import StoreAPI from '@/api/store';
import CatalogAPI from '@/api/catalog';
import ScheduleAPI from '@/api/schedule';
import DeliveryPlatformAPI from '@/api/deliveryPlatform';

import AppBridge from '@/plugins/app';
import DesktopBridge from '@/plugins/desktop';
import { Print as DesktopPrint } from '@/plugins/print';
import store from '@/store';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseLabel from '@/components/Label';
import BaseSelect from '@/components/Select';
import BaseBox from '@/components/Box';
import BaseTabs from '@/components/Tabs';
import BaseInput from '@/components/Input';
import BaseLoading from '@/components/Loading';

import Utils from '@/utils';
import router from '../../router';

export default {
  data() {
    return {
      DeliveryType,
      Status,
      search: {
        id: null,
        enabled: true,
        filter: false,
        selectedIndex: 0,
        date: DateTimeTools.subTime(new Date(), 'hour', 6),
        term: null,
      },
      loading: false,
      showTags: false,
      isTyping: false,
      term: '',
      period: [new Date('2000-01-01'), new Date()],
      noPeriod: true,
      filterType: 5,
      page: 1,
      limit: 10,
      targetOrderReload: 0,
      printers: [],
      catalog: '',
      selectedIndex: 2,
      targetOrder: {},
      drawerDetail: false,
      drawerDetailClose: false,
      infiniteHandlerLimit: false,
      drawers: {
        filter: {
          open: false,
          close: false,
        },
      },
      aOrders: {
        in_production: {
          id: 2,
          name: StringLanguage.production,
          orders: [],
        },
        delivery: {
          id: 3,
          name: 'Entrega',
          orders: [],
        },
        finished: {
          id: 4,
          name: StringLanguage.finished,
          orders: [],
        },
      },
      timerId: null,
      statusChangeTimer: 0,
      originalOrders: null,
      scheduledOrders: null,
      countOrders: {
        total: 0,
        [Status.IN_PRODUCTION]: 0,
        [Status.ON_DELIVERY]: 0,
        [Status.FINISHED]: 0,
      },
    };
  },
  updated() {
    if (this.countOrders[2] > 0 || this.countOrders[3] > 0) {
      store.commit('store/setHasPendingOrders', true);
    }
  },

  created() {
    return StoreAPI.storeGetConfiguration('printers', false).then(
      (printerResponse) => {
        if (printerResponse.getErrors([]).length > 0) this.printers = [];
        else this.printers = printerResponse.getData({}).printers;
      }
    );
  },
  methods: {
    startDrawerTimer(targetOrder) {
      if (targetOrder.schedule) {
        const currentTime = new Date().getTime();
        const scheduledTime = new Date(targetOrder.schedule.date).getTime();
        const timerSeconds = targetOrder.schedule.timer / 1000;

        const secondsPassed = Math.trunc((currentTime - scheduledTime) / 1000);
        if (secondsPassed < timerSeconds) {
          this.drawerTimer(timerSeconds - secondsPassed);
        }
      }
    },
    drawerTimer(seconds) {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.statusChangeTimer = seconds;
      this.timerId = setInterval(() => {
        if (this.statusChangeTimer > 0) {
          this.statusChangeTimer--;
        } else {
          this.resetTimer();
        }
      }, 1000);
    },
    resetTimer() {
      this.drawerDetailClose = !this.drawerDetailClose;
      this.statusChangeTimer = 0;
      clearInterval(this.timerId);
      this.timerId = null;
    },
    isOrderEditable() {
      return (
        this.targetOrder.origin != OrderOrigin.APP &&
        this.targetOrder.status == Status.IN_PRODUCTION
      );
    },
    addAcceptedOrder(order) {
      if (!this.term && this.noPeriod) {
        this.aOrders.in_production.orders.unshift(order);
        this.countOrders[Status.IN_PRODUCTION]++;
        this.countOrders.total++;
      }
    },
    updateEditedOrder(editedOrder) {
      if (this.targetOrder.id == editedOrder.id) {
        this.targetOrder = editedOrder;
        this.targetOrderReload += 1;
      }

      for (const key of Object.keys(this.aOrders)) {
        const index = this.aOrders[key].orders.findIndex(
          (o) => o.id == editedOrder.id
        );

        if (index !== -1) {
          const { schedule } = this.aOrders[key].orders[index];
          if (schedule) {
            editedOrder.schedule = schedule;
            editedOrder.status = schedule.data.status;
          }

          this.aOrders[key].orders.splice(index, 1, editedOrder);
          break;
        }
      }
    },
    removeCanceledOrder(canceledOrder) {
      for (const key of Object.keys(this.aOrders)) {
        const index = this.aOrders[key].orders.findIndex(
          (o) => o.id == canceledOrder.id
        );

        if (index !== -1) {
          const { status } = this.aOrders[key].orders[index];

          this.aOrders[key].orders.splice(index, 1);
          this.countOrders[status]--;
          this.countOrders.total--;
          break;
        }
      }
    },
    async changeStatus(order) {
      const self = this;

      switch (order.status) {
        case Status.IN_PRODUCTION:
          OrderAPI.accept(order.id).then((response) => {
            this.page = 1;
            self.searchOrders(this.period);
            self.drawerDetailClose = !self.drawerDetailClose;
            this.scheduleOrderStatus(this.mountOrderSchedule(order, 'finish'));
          });
          this.scheduleOrderStatus(this.mountOrderSchedule(order, 'finish'));

          break;
        case Status.ON_DELIVERY:
          this.scheduleOrderStatus(this.mountOrderSchedule(order, 'delivery'));
          break;
        case Status.FINISHED:
          this.scheduleOrderStatus(this.mountOrderSchedule(order, 'finish'));
          this.scheduleOrderDeliveryStatus(
            this.mountOrderDeliverySchedule(
              order,
              Object.keys(PlatformShippingStatus)
                .find(
                  (statusName) =>
                    PlatformShippingStatus[statusName] ===
                    PlatformShippingStatus.CLOSED
                )
                .toLowerCase()
            )
          );
          break;
        case Status.CANCELLED:
          OrderAPI.cancel(order.id).then((response) => {
            const cancelledData = response.getData({});
            if (
              cancelledData.delivery &&
              cancelledData.delivery.deliveryPlatformShipping
            )
              DeliveryPlatformAPI.putDeliveryStatus(
                'foody_delivery',
                order.id,
                Object.keys(PlatformShippingStatus)
                  .find(
                    (statusName) =>
                      PlatformShippingStatus[statusName] ===
                      PlatformShippingStatus.CANCELLED
                  )
                  .toLowerCase()
              );
            self.drawerDetailClose = !self.drawerDetailClose;
          });
          await this.print('whenCancelingOrders');
          break;
      }
    },
    mountOrderSchedule(order, statusName) {
      if (
        statusName === 'finish' &&
        this.countOrders[2] + this.countOrders[3] <= 1
      ) {
        store.commit('store/setHasPendingOrders', false);
      }

      return {
        extraId: order.id,
        url: `/status/${statusName}/${order.id}`,
        method: 'put',
        timer: 30000,
        extraTime: 2000,
        type: 'changeOrderStatus',
        data: order,
        service: 'order',
      };
    },

    scheduleOrderStatus(schedule, err) {
      ScheduleAPI.create(schedule).then((response) => {
        const errors = response.getErrors([]);
        if (errors.length > 0 && !err) {
          alert(StringLanguage.orderStatusAlreadyChanged);
        }
      });
    },
    usncheduleOrderStatus(schedule) {
      ScheduleAPI.unschedule('changeOrderStatus', schedule.id).then(
        (response) => {
          const errors = response.getErrors([]);
          if (errors.length > 0) {
            alert(StringLanguage.orderStatusAlreadyChanged);
          } else if (schedule.status === Status.FINISHED)
            this.usncheduleOrderDeliveryStatus(schedule);
        }
      );
    },
    mountOrderDeliverySchedule(order, deliveryStatusName) {
      const platformId = order.delivery.deliveryPlatformShipping
        ? order.delivery.deliveryPlatformShipping.type_id
        : null;

      if (!platformId) return null;

      const platform = Object.keys(DeliveryPlatformEnum)
        .find(
          (platformName) => DeliveryPlatformEnum[platformName] === platformId
        )
        .toLowerCase();

      const schedulePayload = {
        extraId: order.id,
        url: `/delivery/${platform}/${order.id}/${deliveryStatusName}`,
        method: 'put',
        timer: 30000,
        extraTime: 2000,
        type: 'changeOrderDeliveryStatus',
        data: order,
        service: 'order',
      };

      return schedulePayload;
    },

    scheduleOrderDeliveryStatus(schedule) {
      if (!schedule) return;
      ScheduleAPI.create(schedule);
    },
    usncheduleOrderDeliveryStatus(schedule) {
      ScheduleAPI.unschedule('changeOrderDeliveryStatus', schedule.id);
    },
    openOrder(order) {
      this.targetOrder = order;
      this.targetOrderReload += 1;
      this.drawerDetail = !this.drawerDetail;
    },
    getTabs() {
      return Object.values(this.aOrders).map((aOrder) => {
        return {
          name: aOrder.name,
          value: aOrder.id,
          count: this.countOrders[aOrder.id] || 0,
        };
      });
    },
    setIndex(val) {
      this.selectedIndex = val;
      this.infiniteHandlerLimit = false;
    },
    editOrder(orderId) {
      return router.push({ name: 'atendimento', params: { orderId } });
    },
    async print(trigger) {
      const order = JSON.parse(JSON.stringify(this.targetOrder));

      if (DesktopBridge.isDesktop()) {
        await DesktopPrint(order, 'pedidos', trigger);
        return;
      }

      const dataPrint = await DesktopPrint(order, 'pedidos', trigger, 56, true);
      AppBridge.emit('printData', dataPrint);
    },
    filterPeriod(filter = false) {
      this.page = 1;

      if (filter) {
        this.noPeriod = false;
        this.filterType = filter.type;
        this.period[0] = new Date(filter.periods[0]);
        this.period[1] = new Date(filter.periods[1]);
      }

      this.searchOrders(this.period);
      this.drawers.filter.close = !this.drawers.filter.close;
    },
    removePeriod() {
      this.noPeriod = true;
      this.period = [new Date('1900-01-01'), new Date()];
      this.searchOrders();
    },
    formatDate(date) {
      date = dayjs(date).format('YYYY-MM-DDTHH:mm:ssZ[Z]');

      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    getAll() {
      for (const i in this.aOrders) {
        console.log(responseData[i]);
        this.page == 1
          ? (this.aOrders[i].orders = responseData[i])
          : (this.aOrders[i].orders = this.aOrders[i].orders.concat(
              responseData[i]
            ));
      }
    },
    searchOrders(periods, scroll = false) {
      const self = this;
      return new Promise((resolve) => {
        OrderAPI.list(
          null,
          false,
          periods,
          this.limit,
          this.page,
          this.term
        ).then((response) => {
          ScheduleAPI.getAllByType('changeOrderStatus').then(
            (scheduleResponse) => {
              const schedules = scheduleResponse.getData([]);
              this.scheduledOrders = schedules.filter(
                (schedule) => schedule.status === ScheduleStatus.SCHEDULED
              );
              const responseData = response.getData({});
              // valores em produção

              if (this.isMobile) {
                const tabKey = this.getTabKey(this.selectedIndex);
                if (responseData[tabKey].length === 0) {
                  this.infiniteHandlerLimit = !this.infiniteHandlerLimit;
                }
              }

              if (responseData.count && responseData.count.length) {
                const groupByStatus = responseData.count.reduce(
                  (result, item) => {
                    (result[item.status] = result[item.status] || []).push(
                      item
                    );
                    return result;
                  },
                  {}
                );

                this.countOrders = {
                  total: responseData.count.length || 0,
                  [Status.IN_PRODUCTION]: groupByStatus[Status.IN_PRODUCTION]
                    ? groupByStatus[Status.IN_PRODUCTION].length
                    : 0,
                  [Status.ON_DELIVERY]: groupByStatus[Status.ON_DELIVERY]
                    ? groupByStatus[Status.ON_DELIVERY].length
                    : 0,
                  [Status.FINISHED]: groupByStatus[Status.FINISHED]
                    ? groupByStatus[Status.FINISHED].length
                    : 0,
                };
              }

              const existOrders = Object.entries(responseData).filter(
                (item) => item[0] !== 'count' && item[1].length > 0
              ).length;

              if (existOrders == 0) {
                if (!scroll) {
                  this.countOrders = {
                    total: 0,
                    [Status.IN_PRODUCTION]: 0,
                    [Status.ON_DELIVERY]: 0,
                    [Status.FINISHED]: 0,
                  };

                  for (const orderStatus in this.aOrders) {
                    this.aOrders[orderStatus].orders = [];
                  }
                }
                resolve(false);
              }

              for (const orderStatus in this.aOrders) {
                if (responseData[orderStatus])
                  if (this.page == 1) {
                    this.aOrders[orderStatus].orders =
                      responseData[orderStatus];
                  } else {
                    const mergedOrders = this.aOrders[
                      orderStatus
                    ].orders.concat(responseData[orderStatus]);
                    this.aOrders[orderStatus].orders = mergedOrders;
                  }
              }
              this.mergeScheduledOrders();
              this.loading = false;
              resolve(true);
            }
          );
        });
      });
    },
    mergeScheduledOrders() {
      this.scheduledOrders
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .forEach((schedule) => {
          this.changeOrderGroup(
            schedule,
            schedule.data.originalStatus,
            schedule.data.status
          );
        });
    },
    changeOrderGroup(schedule, fromStatus, toStatus) {
      const from = this.getTabKey(fromStatus);
      const to = this.getTabKey(toStatus);

      // Obtém os dados do pedido que está mudando de status
      let order = this.aOrders[from].orders.find(
        (o) => o.id == schedule.data.id
      );

      // Não deve listar o pedido caso esteja havendo uma busca ou filtro e o pedido não estiver pré-carregado
      if (!order && (this.term || !this.noPeriod)) {
        return;
      }

      // Atualiza o contador das colunas
      if (order) {
        if (this.countOrders[fromStatus] > 0) this.countOrders[fromStatus]--;
        this.countOrders[toStatus]++;
      }

      // Se o pedido já estiver carregado, deve-se removê-lo da coluna de origem
      if (order) {
        const orderIndex = this.aOrders[from].orders.indexOf(order);
        this.aOrders[from].orders.splice(orderIndex, 1);
      } else {
        order = schedule.data;
      }

      // Se for um cancelamento, deve-se remover as informações de agendamento do objeto
      if (fromStatus < toStatus) {
        order.schedule = schedule;
      } else {
        delete order.schedule;
      }

      //  Verifica se o pedido já está na coluna de destino
      if (this.aOrders[to].orders.find((o) => o.id == schedule.data.id)) {
        return;
      }

      // Adiciona o pedido na coluna de destino
      this.aOrders[to].orders.unshift({
        ...order,
        status: toStatus,
      });

      // Quando os pedidos, de uma coluna, acabarem, deve-se carregar mais pedidos
      if (
        this.countOrders[fromStatus] > 0 &&
        this.aOrders[from].orders.length === 0
      ) {
        this.searchOrders(this.period);
        this.page++;
      }
    },
    getStatusName(status) {
      switch (status) {
        case Status.ON_DELIVERY:
          return StringLanguage.onDelivery;
        case Status.FINISHED:
          return StringLanguage.finished;
        default:
          return StringLanguage.inProduction;
      }
    },
    getTabKey(tabIndex) {
      switch (tabIndex) {
        case 0:
        case 2:
          return 'in_production';
        case 3:
          return 'delivery';
        case 4:
          return 'finished';
      }
    },
    async infiniteHandler($state) {
      const result = await this.searchOrders(this.period, true);
      if (result) {
        this.page++;
        $state.loaded();
      } else {
        $state.complete();
      }

      const windowHeight = window.innerHeight;

      if (this.countOrders.total <= 2 && result && windowHeight <= 700) {
        $state.complete();
      } else if (this.countOrders.total <= 3 && result && windowHeight > 700) {
        $state.complete();
      }
    },
  },
  components: {
    BaseDrawer,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseCard,
    BaseLabel,
    BaseSelect,
    BaseTabs,
    BaseInput,
    OrdersKanban,
    OrdersDetail,
    FilterPeriod,
    InfiniteLoading,
    BaseLoading,
    BaseEmpty,
  },

  computed: {
    tabActived() {
      return Object.values(this.aOrders)
        .map((aOrder) => aOrder.id)
        .indexOf(this.selectedIndex);
    },
    ...mapState({
      newChangeOrderStatus: (state) => state.socket.newChangeOrderStatus,
      cancelChangeOrderStatus: (state) => state.socket.cancelChangeOrderStatus,
      newAcceptedOrder: (state) => state.socket.newAcceptedOrder,
      newEditedOrder: (state) => state.socket.newEditedOrder,
      newCanceledOrder: (state) => state.socket.newCanceledOrder,
      isMobile: (state) => state.store.isMobile,
      hasPendingOrders: (state) => state.store.hasPendingOrders,
    }),
  },
  watch: {
    newChangeOrderStatus(schedule) {
      this.changeOrderGroup(
        schedule,
        schedule.data.originalStatus,
        schedule.data.status
      );
    },
    cancelChangeOrderStatus(schedule) {
      this.changeOrderGroup(
        schedule,
        schedule.data.status,
        schedule.data.originalStatus
      );
    },
    newAcceptedOrder(order) {
      this.addAcceptedOrder(order);
    },
    newEditedOrder(order) {
      this.updateEditedOrder(order);
    },
    newCanceledOrder(order) {
      this.removeCanceledOrder(order);
    },
    term: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping(value) {
      if (!value) {
        this.page = 1;
        this.searchOrders(this.period);
      }
    },
  },
  filters: {
    timerLabel(timer) {
      return `Desfazer (${timer}s)`;
    },
  },
};
</script>

<style scoped>
.box-search {
  margin-bottom: 55px;
}

.search-n-filter {
  transition: 0.2s all linear;
  height: 92px;
  overflow: hidden;
  padding: 0;
}
.search-n-filter.opened {
  height: 170px;
}
.search-box {
  display: flex;
  padding: 7px 20px 2px 20px !important;
}

.tag {
  background: var(--box-up);
  padding: 4px 12px;
  margin-left: 10px;
  border-radius: 5px;
  color: #aaaaaae6;
  font-size: 14px;
  line-height: 17px;
  position: relative;
}
.tag.period {
  padding-right: 30px;
}
.tags-mobile .tag {
  margin-left: 0 !important;
  margin-top: 10px;
  padding: 10px 15px;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}

.search-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

@media screen and (max-width: 991px) {
  .search-n-filter.opened {
    height: 278px;
  }
  .tag {
    font-size: 12px;
  }
  .tag.period {
    margin-top: 15px;
    width: 100%;
    margin-left: 0;
  }
  .box-search {
    margin-bottom: 35px;
    padding: 15px;
  }
}
</style>
